(function expandableBlock() {
    var expandableSections = document.querySelectorAll("[data-expandable=\"true\"]");

    if (expandableSections.length > 0) {
        for (var i = 0; i < expandableSections.length; i++) {
            var header = expandableSections[i].querySelector("h3");
            if (header) {
                header.addEventListener("click", expandCollapse, false);
                header.addEventListener("keypress", function (e) {
                    var key = e.which || e.keyCode;
                    if (key === 13) {
                        expandCollapse.call(e.currentTarget);
                    }
                }, false);
            }
        }
    }

    function expandCollapse() {
        var thisSection = this.parentNode;
        var isOpen = thisSection.classList.contains("open");

        for (var i = 0; i < expandableSections.length; i++) {
            expandableSections[i].classList.remove("open");
            expandableSections[i].setAttribute("aria-expanded", "false");
        }

        if (!isOpen) {
            thisSection.classList.add("open");
            thisSection.setAttribute("aria-expanded", "true");
        }
    }
})();
